// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PathCondition } from '@alme/ui-web/settings/settings';

export default {
    // TODO: add additional settings here.
    Cookies: {
        NITAlme: {
            getOptions: {
                domain: process.env.cookie_store_domain,
            },
            setOptions: {
                domain: process.env.cookie_store_domain,
            },
        },
        NITAlmeUser: {
            getOptions: {
                domain: process.env.cookie_store_domain,
            },
            setOptions: {
                domain: process.env.cookie_store_domain,
            },
        },
        domainMap: {
            "nidevamwalme301.ebu.nextnet.com": "",
            "niqaamwalme301.ebu.nextnet.com": "",
            "localhost": "",
        },
    },
    Drag: {
        snapGutterPixels : 10,
    },
    Error: {
        displayMultipleErrorsInHistory : false,
    },
    FPMLParameters:{
      IsUserLoggedIn:{
        cookieName: "LoginCookie",
        sessionStorageKey: "ibsession",
      },
    },
    Mobile: {
        browserWidth: 690,
        agentHeight: 350,
        agentWidth: 350,
      },
      Popper: {
        responseOffset: 112,
      },
      UrlReplacer: {
        HostMaps: process.env.HOST_REPLACEMENT_MAPS,
      },
      utc: {
        utcParamName : "UTCDateTime",
        utcFormat: "yyyy-mm-dd HH:MM:ss",
      },
      weblinkConstants: {},
      endSession: {
        ignoreMessageSource: ["LiveChatGetNotification"],
        },
      ExtensibleAlmeAPI: {
       notificationsApi: 'ConversationSupport/GetPendingMessages',
    },
};


// WEBPACK FOOTER //
// ./settings/settings.ts